import { render, staticRenderFns } from "./standars.vue?vue&type=template&id=4a23449d"
import script from "./standars.vue?vue&type=script&lang=js"
export * from "./standars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports